import { Theme } from '@mui/material/styles'

const muiDrawer = (theme: Theme) => {
  return {
    styleOverrides: {
      paper: {
        background: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: 'none',
        borderRight: `1px solid ${theme.colors.stroke}`,
        zIndex: 1201,
        overflowX: 'hidden'
      }
    }
  }
}

export default muiDrawer
